import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {CartActions} from '@spartacus/cart/base/core';
import {ActiveCartFacade, Cart} from '@spartacus/cart/base/root';
import {UserIdService} from '@spartacus/core';
import {map, mergeMap, take, withLatestFrom} from 'rxjs/operators';
import {DcpCartService} from '../../../product/services/dcp-cart.service';
import {PoNumberActionTypes, SetPoNumber} from '../actions/po-number.action';

@Injectable()
export class PoNumberEffects {
  constructor(
    private actions$: Actions,
    private cartService: DcpCartService,
    private activeCartFacade: ActiveCartFacade,
    private userIdService: UserIdService
  ) {}

  setPoNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PoNumberActionTypes.SetPoNumber),
      mergeMap((action: SetPoNumber) =>
        this.cartService.savePoNumber(action.payload.poNumber).pipe(
          mergeMap(() => this.activeCartFacade.getActive().pipe(take(1))),
          withLatestFrom(this.userIdService.getUserId()),
          map(([cart, userId]: [Cart, string]) => {
            const newCart = {
              ...cart,
              purchaseOrderNumber: action.payload.poNumber
            };

            return new CartActions.LoadCartSuccess({
              cart: newCart,
              cartId: cart.code,
              userId,
            });
          })
        )
      )
    )
  );
}
